import { render, staticRenderFns } from "./ChordsModal.vue?vue&type=template&id=22c6c886&scoped=true"
import script from "./ChordsModal.vue?vue&type=script&lang=ts"
export * from "./ChordsModal.vue?vue&type=script&lang=ts"
import style0 from "./ChordsModal.vue?vue&type=style&index=0&id=22c6c886&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6c886",
  null
  
)

export default component.exports